



document.addEventListener("DOMContentLoaded", () => {
    const body = document.body;

    /* -----------------------------
       MOBILE MENU
    ------------------------------ */
    const mobileMenu = document.getElementById("mobileMenu");
    const mobileMenuOverlay = document.getElementById("mobileMenuOverlay");
    const hamburgerBtn = document.getElementById("hamburgerBtn");
    const mobileMenuCloseButtons = mobileMenu ? mobileMenu.querySelectorAll(".mobile-menu__close") : [];
    const mobileMenuPanels = mobileMenu ? [...mobileMenu.querySelectorAll(".mobile-menu__panel")] : [];
    const mobileMainMenu = document.getElementById("mobileMainMenu");

    function showMobilePanel(panelId) {
        mobileMenuPanels.forEach((panel) => {
            panel.classList.toggle("active", panel.id === panelId);
        });
    }

    function closeMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.remove("active");
        mobileMenuOverlay?.classList.remove("active");
        body.classList.remove("menu-open");
        showMobilePanel("mobileMainMenu");
        mobileMenu.querySelectorAll(".mobile-menu__group").forEach((group) => group.classList.remove("open"));
    }

    function openMobileMenu() {
        if (!mobileMenu || !mobileMenuOverlay) return;
        closeFilterDrawer();
        mobileMenu.classList.add("active");
        mobileMenuOverlay.classList.add("active");
        body.classList.add("menu-open");
        showMobilePanel("mobileMainMenu");
    }

    hamburgerBtn?.addEventListener("click", openMobileMenu);
    mobileMenuCloseButtons.forEach((btn) => btn.addEventListener("click", closeMobileMenu));
    mobileMenuOverlay?.addEventListener("click", closeMobileMenu);

    mobileMenu?.querySelectorAll(".mobile-menu__item.has-children").forEach((btn) => {
        btn.addEventListener("click", () => {
            const target = btn.dataset.target;
            if (target) showMobilePanel(`submenu-${target}`);
        });
    });

    mobileMenu?.querySelectorAll("[data-back]").forEach((btn) => {
        btn.addEventListener("click", () => showMobilePanel("mobileMainMenu"));
    });

    mobileMenu?.querySelectorAll(".mobile-menu__group-head").forEach((btn) => {
        btn.addEventListener("click", () => {
            const group = btn.closest(".mobile-menu__group");
            group?.classList.toggle("open");
        });
    });

    mobileMenu?.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", closeMobileMenu);
    });

    /* -----------------------------
       FILTER DRAWER
    ------------------------------ */
    const openFilterBtn = document.getElementById("openFilterBtn");
    const filterDrawer = document.getElementById("filterDrawer");
    const filterOverlay = document.getElementById("filter-overlay");
    const drawerCloseBtn = document.getElementById("closeFilter");
    const drawerApplyBtn = document.getElementById("applyFilter");
    const MOBILE_FILTER_MAX_WIDTH = 1024;

    /** @type {Map<HTMLInputElement, boolean> | null} */
    let drawerFilterSnapshot = null;

    function isMobileFilterViewport() {
        return window.innerWidth <= MOBILE_FILTER_MAX_WIDTH;
    }

    function isInFilterDrawer(element) {
        return Boolean(filterDrawer && element && filterDrawer.contains(element));
    }

    function captureDrawerFilterSnapshot() {
        const snapshot = new Map();
        filterCheckboxes.forEach((cb) => {
            snapshot.set(cb, cb.checked);
        });
        drawerFilterSnapshot = snapshot;
    }

    function restoreDrawerFilterSnapshot() {
        if (!drawerFilterSnapshot) return;
        drawerFilterSnapshot.forEach((checked, cb) => {
            cb.checked = checked;
        });
        drawerFilterSnapshot = null;
    }

    function discardDrawerFilterSnapshot() {
        drawerFilterSnapshot = null;
    }

    function openFilterDrawer() {
        if (!filterDrawer || !isMobileFilterViewport()) return;
        closeMobileMenu();
        captureDrawerFilterSnapshot();
        filterDrawer.classList.add("active");
        filterOverlay?.classList.add("active");
        body.classList.add("menu-open");
    }

    function closeFilterDrawer({ restorePending = true } = {}) {
        if (!filterDrawer) return;
        if (restorePending) {
            restoreDrawerFilterSnapshot();
        } else {
            discardDrawerFilterSnapshot();
        }
        filterDrawer.classList.remove("active");
        filterOverlay?.classList.remove("active");
        body.classList.remove("menu-open");
    }

    openFilterBtn?.addEventListener("click", openFilterDrawer);
    drawerCloseBtn?.addEventListener("click", () => closeFilterDrawer({ restorePending: true }));
    drawerApplyBtn?.addEventListener("click", () => {
        const drawerForm = filterDrawer?.querySelector("[data-main-category-filter-form]");
        if (drawerForm instanceof HTMLFormElement) {
            drawerForm.requestSubmit();
        }
        closeFilterDrawer({ restorePending: false });
    });
    filterOverlay?.addEventListener("click", () => closeFilterDrawer({ restorePending: true }));

    /* -----------------------------
       FILTER CHIPS + SYNC
    ------------------------------ */
    const activeFiltersBar = document.getElementById("activeFilters");
    const filterCheckboxes = [...document.querySelectorAll(".filter-checkbox")];
    const countEls = [...document.querySelectorAll(".filter-count")];
    const clearBtns = [
        document.getElementById("clearAllBtn"),
        document.getElementById("filter-clearAll"),
    ].filter(Boolean);

    function normalizeLabel(text) {
        return (text || "")
            .replace(/\(\d+\)/g, "")
            .replace(/\s+/g, " ")
            .trim();
    }

    function getLabel(input) {
        return normalizeLabel(input.dataset.label || input.closest("label")?.textContent || "Filter");
    }

    function syncCheckboxesByLabel(label, checked) {
        filterCheckboxes.forEach((cb) => {
            if (getLabel(cb) === label) cb.checked = checked;
        });
    }

    function selectedLabels() {
        return [...new Set(filterCheckboxes.filter((cb) => cb.checked).map(getLabel))];
    }

    function submitMainCategoryFilters() {
        const form = isMobileFilterViewport()
            ? filterDrawer?.querySelector("[data-main-category-filter-form]") ||
              document.querySelector("[data-main-category-filter-form]")
            : document.querySelector("#filterSidebar [data-main-category-filter-form]") ||
              document.querySelector("[data-main-category-filter-form]");
        if (form instanceof HTMLFormElement) {
            form.requestSubmit();
        }
    }

    function shouldDeferFilterSubmit(triggerEl) {
        return isMobileFilterViewport() && isInFilterDrawer(triggerEl);
    }

    function renderFilterChips() {
        if (!activeFiltersBar) return;

        const labels = selectedLabels();
        activeFiltersBar.innerHTML = "";

        labels.forEach((label) => {
            const chip = document.createElement("div");
            chip.className = "filter-chip";
            chip.dataset.value = label;
            chip.innerHTML = `<span>${label}</span><button type="button" aria-label="Remove ${label}">&times;</button>`;

            chip.querySelector("button")?.addEventListener("click", () => {
                syncCheckboxesByLabel(label, false);
                renderFilterChips();
                submitMainCategoryFilters();
            });

            activeFiltersBar.appendChild(chip);
        });

        activeFiltersBar.hidden = labels.length === 0;
        countEls.forEach((el) => {
            el.textContent = labels.length ? `| ${labels.length}` : "";
        });
    }

    function clearAllFilters() {
        filterCheckboxes.forEach((cb) => {
            cb.checked = false;
        });
        renderFilterChips();
        submitMainCategoryFilters();
    }

    filterCheckboxes.forEach((cb) => {
        cb.addEventListener("change", () => {
            const mcForm = cb.closest("[data-main-category-filter-form]");
            const label = getLabel(cb);

            if (mcForm && shouldDeferFilterSubmit(cb)) {
                syncCheckboxesByLabel(label, cb.checked);
                countEls.forEach((el) => {
                    const count = selectedLabels().length;
                    el.textContent = count ? `| ${count}` : "";
                });
                return;
            }

            if (mcForm) {
                syncCheckboxesByLabel(label, cb.checked);
                mcForm.requestSubmit();
                return;
            }

            syncCheckboxesByLabel(label, cb.checked);
            renderFilterChips();
        });
    });

    clearBtns.forEach((btn) => {
        if (btn instanceof HTMLAnchorElement) return;
        btn.addEventListener("click", clearAllFilters);
    });

    renderFilterChips();

    const mainCategoryPriceSubmitDelayMs = 500;
    const mainCategoryPriceSubmitTimers = new WeakMap();

    document.querySelectorAll("[data-main-category-filter-form]").forEach((form) => {
        form.addEventListener("change", (event) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            if (!target.matches(".cc-price-range__input")) return;
            if (shouldDeferFilterSubmit(target)) return;

            const prev = mainCategoryPriceSubmitTimers.get(form);
            if (prev) window.clearTimeout(prev);

            const timer = window.setTimeout(() => {
                mainCategoryPriceSubmitTimers.delete(form);
                form.requestSubmit();
            }, mainCategoryPriceSubmitDelayMs);

            mainCategoryPriceSubmitTimers.set(form, timer);
        });
    });

    /* -----------------------------
       ACCORDION (DESKTOP SIDEBAR)
    ------------------------------ */
    document.querySelectorAll(".accordion-toggle").forEach((btn) => {
        btn.addEventListener("click", () => {
            const block = btn.closest(".filter-block");
            block?.classList.toggle("closed");
        });
    });

    /* -----------------------------
       FILTER LIST PAGINATION (5 visible, +8 more, view less)
    ------------------------------ */
    const FILTER_PAGINATION_INITIAL = 5;
    const FILTER_PAGINATION_BATCH = 8;

    const applyFilterListItemVisibility = (item) => {
        const searchHidden = item.getAttribute("data-filter-search-hidden") === "true";
        const paginationHidden = item.getAttribute("data-filter-pagination-hidden") === "true";
        item.hidden = searchHidden || paginationHidden;
    };

    const getFilterListItems = (list) => {
        if (list.classList.contains("color-list")) {
            return [...list.querySelectorAll("[data-color-filter-item]")];
        }
        if (list.classList.contains("checklist")) {
            return [...list.querySelectorAll(":scope > .check")];
        }
        return [];
    };

    const updateFilterPaginationToggleLabel = (toggleBtn, visibleCount, total) => {
        if (visibleCount >= total) {
            toggleBtn.textContent = "View less";
            toggleBtn.setAttribute("aria-expanded", "true");
            return;
        }

        const remaining = total - visibleCount;
        const nextBatch = Math.min(FILTER_PAGINATION_BATCH, remaining);
        toggleBtn.textContent = `+${nextBatch} more`;
        toggleBtn.setAttribute("aria-expanded", "false");
    };

    const setFilterListVisibleCount = (items, visibleCount) => {
        items.forEach((item, index) => {
            item.setAttribute("data-filter-pagination-hidden", index >= visibleCount ? "true" : "false");
            applyFilterListItemVisibility(item);
        });
    };

    const getFilterPaginationVisibleCount = (list) => {
        const stored = Number(list.dataset.filterPaginationVisibleCount);
        return Number.isFinite(stored) && stored > 0 ? stored : FILTER_PAGINATION_INITIAL;
    };

    const refreshFilterListPagination = (list, toggleBtn) => {
        const items = getFilterListItems(list);
        const visibleCount = getFilterPaginationVisibleCount(list);
        setFilterListVisibleCount(items, visibleCount);
        if (toggleBtn) {
            updateFilterPaginationToggleLabel(toggleBtn, visibleCount, items.length);
            toggleBtn.hidden = false;
        }
    };

    const initFilterListPagination = (root = document) => {
        root.querySelectorAll(".accordion-body").forEach((body) => {
            const list = body.querySelector(".checklist, .color-list");
            if (!list || list.hasAttribute("data-filter-pagination-initialized")) return;

            const items = getFilterListItems(list);
            if (items.length <= FILTER_PAGINATION_INITIAL) return;

            list.setAttribute("data-filter-pagination-initialized", "");
            list.dataset.filterPaginationVisibleCount = String(FILTER_PAGINATION_INITIAL);

            const toggleBtn = document.createElement("button");
            toggleBtn.type = "button";
            toggleBtn.className = "more";
            toggleBtn.setAttribute("data-filter-pagination-toggle", "");
            list.insertAdjacentElement("afterend", toggleBtn);

            toggleBtn.addEventListener("click", () => {
                let visibleCount = getFilterPaginationVisibleCount(list);
                if (visibleCount >= items.length) {
                    visibleCount = FILTER_PAGINATION_INITIAL;
                } else {
                    visibleCount = Math.min(items.length, visibleCount + FILTER_PAGINATION_BATCH);
                }
                list.dataset.filterPaginationVisibleCount = String(visibleCount);
                refreshFilterListPagination(list, toggleBtn);
            });

            refreshFilterListPagination(list, toggleBtn);
        });
    };

    initFilterListPagination();

    /* -----------------------------
       PRICE SLIDERS
    ------------------------------ */
    /* -----------------------------
       COLLECTION SORT (Shopify URLs)
    ------------------------------ */
    for (const select of document.querySelectorAll("select[data-main-category-sort]")) {
        select.addEventListener("change", () => {
            const selected = select.options[select.selectedIndex];
            const url = selected?.dataset?.url;
            if (url) {
                window.location.href = url;
            }
        });
    }

    document.querySelectorAll("[data-color-filter-search]").forEach((searchInput) => {
        searchInput.addEventListener("input", () => {
            const q = searchInput.value.toLowerCase().trim();
            const body = searchInput.closest(".accordion-body");
            if (!body) return;

            const list = body.querySelector(".color-list");
            const toggleBtn = body.querySelector("[data-filter-pagination-toggle]");
            const isColorSearchActive = q.length > 0;

            if (toggleBtn instanceof HTMLButtonElement) {
                toggleBtn.hidden = isColorSearchActive;
            }

            for (const item of body.querySelectorAll("[data-color-filter-item]")) {
                const handle = (item.dataset.colorSearchHandle || "").toLowerCase();
                const text = item.textContent.toLowerCase();
                const match = !isColorSearchActive || handle.includes(q) || text.includes(q);
                item.setAttribute("data-filter-search-hidden", match ? "false" : "true");
                if (isColorSearchActive) {
                    item.setAttribute("data-filter-pagination-hidden", "false");
                }
                applyFilterListItemVisibility(item);
            }

            if (!isColorSearchActive && list instanceof HTMLElement && toggleBtn instanceof HTMLButtonElement) {
                refreshFilterListPagination(list, toggleBtn);
            }
        });
    });

    /* -----------------------------
       MAIN CATEGORY PRODUCT GRID (Swiper + cart + swatches)
    ------------------------------ */
    const kptMoneyCache = new Map();

    const formatKptMoney = (cents, currency) => {
        const c = currency || "USD";
        const n = Number(cents);
        if (!Number.isFinite(n)) return "";
        const key = `${c}:${n}`;
        if (kptMoneyCache.has(key)) return kptMoneyCache.get(key);
        let out = "";
        try {
            out = new Intl.NumberFormat(document.documentElement.lang || undefined, {
                style: "currency",
                currency: c,
            }).format(n / 100);
        } catch {
            out = `₹${(n / 100).toFixed(2)}`;
        }
        kptMoneyCache.set(key, out);
        return out;
    };

    const initKptImageSwipers = (root) => {
        if (typeof window.Swiper !== "function" || !root) return;

        const sliders = Array.from(root.querySelectorAll("[data-kpt-image-swiper]"));
        for (const slider of sliders) {
            if (slider.swiper) {
                slider.swiper.update();
                continue;
            }

            const area = slider.closest(".kpt-image-area");
            const paginationEl =
                slider.querySelector("[data-kpt-image-pagination]") ||
                slider.querySelector(".swiper-pagination") ||
                area?.querySelector("[data-kpt-image-pagination]");
            const slideEls = slider.querySelectorAll(".swiper-slide");
            if (slideEls.length < 2) continue;

            /** @type {Record<string, unknown>} */
            const swiperOpts = {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: slideEls.length >= 3,
                speed: 450,
                grabCursor: true,
                watchOverflow: true,
            };

            if (paginationEl instanceof HTMLElement) {
                swiperOpts.pagination = { el: paginationEl, clickable: true };
            }

            new window.Swiper(slider, swiperOpts);
        }
    };

    const bindKptProductGrid = () => {
        if (window.__kptMainCategoryGridBound) return;
        window.__kptMainCategoryGridBound = true;

        document.addEventListener("click", async (e) => {
            const sw = e.target.closest(
                "[data-kpt-product-grid-root] [data-kpt-swatch-row] .pi-color-dot, [data-kairaus-pdp-recommendations] [data-kpt-swatch-row] .pi-color-dot, [data-kairaus-recently-viewed] [data-kpt-swatch-row] .pi-color-dot"
            );
            if (sw instanceof HTMLButtonElement && !sw.disabled) {
                const row = sw.closest("[data-kpt-swatch-row]");
                const card = sw.closest("[data-kpt-card]");
                if (!row || !card) return;
                e.preventDefault();

                for (const b of row.querySelectorAll(".pi-color-dot")) {
                    b.classList.toggle("pi-color-dot--active", b === sw);
                    b.setAttribute("aria-checked", b === sw ? "true" : "false");
                }

                const variantId = sw.getAttribute("data-variant-id");
                const priceCents = sw.getAttribute("data-kpt-price-cents");
                const available = sw.getAttribute("data-kpt-available") === "true";
                const rootEl = card.closest(
                    "[data-kpt-product-grid-root], [data-kairaus-pdp-recommendations], [data-kairaus-recently-viewed]"
                );
                const currency = rootEl?.getAttribute("data-kpt-currency") || "USD";

                const cartBtn = card.querySelector(".cart-btn");
                if (cartBtn instanceof HTMLButtonElement && variantId) {
                    cartBtn.dataset.variantId = variantId;
                    cartBtn.dataset.productId = variantId;
                    cartBtn.disabled = !available;
                }

                const priceEl = card.querySelector("[data-kpt-price-display]");
                if (priceEl && priceCents) {
                    priceEl.textContent = formatKptMoney(priceCents, currency);
                }

                const src = sw.getAttribute("data-kpt-media-src");
                const srcset = sw.getAttribute("data-kpt-media-srcset");
                if (src) {
                    const swEl = card.querySelector("[data-kpt-image-swiper]");
                    if (swEl?.swiper) {
                        swEl.swiper.slideTo(0);
                    }
                    const slideImg = card.querySelector(
                        ".kpt-image-swiper .swiper-slide:first-child img, .image-wrapper > img"
                    );
                    if (slideImg instanceof HTMLImageElement) {
                        slideImg.src = src;
                        if (srcset) slideImg.srcset = srcset;
                    }
                }
                return;
            }

            const btn = e.target.closest(
                "[data-kpt-product-grid-root] .cart-btn, [data-kairaus-pdp-recommendations] .cart-btn, [data-kairaus-recently-viewed] .cart-btn"
            );
            if (!(btn instanceof HTMLButtonElement)) return;
            if (btn.disabled) return;
            e.preventDefault();

            const variantId = btn.dataset.variantId || btn.dataset.productId;
            if (!variantId) return;
            if (btn.getAttribute("aria-disabled") === "true") return;

            const cartUrl = window.theme?.routes?.cartAdd;
            if (!cartUrl) return;

            btn.setAttribute("aria-disabled", "true");
            btn.classList.add("is-loading");

            const formData = new FormData();
            formData.append("id", variantId);
            formData.append("quantity", "1");

            try {
                const response = await fetch(cartUrl, {
                    method: "POST",
                    headers: {
                        Accept: "application/javascript",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: formData,
                });
                const data = await response.json();
                if (!response.ok || data.status) {
                    const msg = data?.description || data?.message || "Unable to add to cart";
                    throw new Error(typeof msg === "string" ? msg : "Unable to add to cart");
                }

                document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
                if (window.theme?.settings?.afterAddToCart === "drawer") {
                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", { bubbles: true }));
                }
            } catch (err) {
                console.error(err);
            } finally {
                btn.classList.remove("is-loading");
                btn.removeAttribute("aria-disabled");
            }
        });
    };

    bindKptProductGrid();

    const kptRoot = document.querySelector("[data-kpt-product-grid-root]");
    const runKptSwiperWhenReady = () => {
        if (!kptRoot) return;
        if (typeof window.Swiper === "function") {
            initKptImageSwipers(kptRoot);
            return;
        }
        let tries = 0;
        const id = window.setInterval(() => {
            tries += 1;
            if (typeof window.Swiper === "function") {
                window.clearInterval(id);
                initKptImageSwipers(kptRoot);
            } else if (tries > 100) {
                window.clearInterval(id);
            }
        }, 50);
    };

    runKptSwiperWhenReady();

    /* -----------------------------
       Main category: AJAX pagination (Section Rendering API)
    ------------------------------ */
    const initMainCategoryPaginationAjax = () => {
        const gridRoot = document.querySelector("[data-kpt-product-grid-root][data-mc-pagination-ajax]");
        if (!gridRoot || gridRoot.getAttribute("data-mc-pagination-ajax") !== "1") return;

        const fragmentSel = "[data-mc-pagination-fragment]";
        const primarySectionId = gridRoot.getAttribute("data-mc-section-render-id") || "";
        const fallbackSectionId = gridRoot.getAttribute("data-mc-section-render-id-fallback") || "main";

        /** @type {AbortController | null} */
        let paginationAbort = null;

        const fetchSectionHtml = async (pageHref, sectionId, signal) => {
            const u = new URL(pageHref, window.location.origin);
            u.searchParams.set("section_id", sectionId);
            const res = await fetch(u.toString(), {
                method: "GET",
                credentials: "same-origin",
                signal,
                headers: { "X-Requested-With": "XMLHttpRequest", Accept: "text/html" },
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
        };

        const parseFragmentFromHtml = (html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.querySelector(fragmentSel);
        };

        const loadFragment = async (pageHref, { pushState } = { pushState: true }) => {
            const currentFrag = gridRoot.querySelector(fragmentSel);
            if (!currentFrag) return false;

            paginationAbort?.abort();
            paginationAbort = new AbortController();
            const { signal } = paginationAbort;

            currentFrag.setAttribute("aria-busy", "true");
            currentFrag.style.opacity = "0.55";
            currentFrag.style.pointerEvents = "none";

            let nextEl = null;

            try {
                let html = await fetchSectionHtml(pageHref, primarySectionId, signal);
                nextEl = parseFragmentFromHtml(html);
                if (!nextEl && fallbackSectionId && fallbackSectionId !== primarySectionId) {
                    html = await fetchSectionHtml(pageHref, fallbackSectionId, signal);
                    nextEl = parseFragmentFromHtml(html);
                }
                if (!nextEl) return false;

                currentFrag.replaceWith(nextEl);
                if (pushState) {
                    const clean = new URL(pageHref, window.location.origin);
                    window.history.pushState({}, "", clean.pathname + clean.search);
                }

                initKptImageSwipers(gridRoot);

                const header = document.querySelector(".section-header");
                const headerH = header instanceof HTMLElement ? header.clientHeight : 0;
                const top = gridRoot.getBoundingClientRect().top + window.scrollY - headerH - 8;
                window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
                return true;
            } catch (err) {
                if (err && err.name === "AbortError") return false;
                console.warn("[main-cat] pagination ajax:", err);
                return false;
            } finally {
                const frag = gridRoot.querySelector(fragmentSel);
                if (frag) {
                    frag.removeAttribute("aria-busy");
                    frag.style.opacity = "";
                    frag.style.pointerEvents = "";
                }
            }
        };

        document.addEventListener(
            "click",
            async (e) => {
                const a = e.target.closest("nav.pagination a[href]");
                if (!(a instanceof HTMLAnchorElement)) return;
                if (!gridRoot.contains(a)) return;

                const href = a.getAttribute("href");
                if (!href || href === "#") return;

                e.preventDefault();
                const ok = await loadFragment(href, { pushState: true });
                if (!ok) window.location.assign(href);
            },
            true
        );

        window.addEventListener("popstate", () => {
            void loadFragment(window.location.href, { pushState: false });
        });
    };

    initMainCategoryPaginationAjax();

    document.addEventListener("shopify:section:load", (evt) => {
        const tgt = evt.target;
        if (!(tgt instanceof HTMLElement)) return;
        initFilterListPagination(tgt);
        const r = tgt.querySelector("[data-kpt-product-grid-root]");
        if (!r) return;
        if (typeof window.Swiper === "function") {
            initKptImageSwipers(r);
        } else {
            window.setTimeout(() => initKptImageSwipers(r), 100);
        }
    });

    /* -----------------------------
       CLOSE ON RESIZE / ESC
    ------------------------------ */
    window.addEventListener("resize", () => {
        if (!isMobileFilterViewport()) {
            closeFilterDrawer({ restorePending: true });
            closeMobileMenu();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeFilterDrawer();
            closeMobileMenu();
        }
    });
});
